import { render } from "./CreateUser.vue?vue&type=template&id=a4fe03c8&ts=true"
import script from "./CreateUser.vue?vue&type=script&lang=ts"
export * from "./CreateUser.vue?vue&type=script&lang=ts"

import "./CreateUser.vue?vue&type=style&index=0&id=a4fe03c8&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__